
import { v4 as uuidv4 } from 'uuid';
import { supabase } from '@/lib/supabase';
import { DeployBotFormValues } from '@/types/bot-forms';
import { Bot, BotType, ColorScheme, ExchangePlatform, SignalSource } from '@/types/trader';
import { createShadowBot } from './shadow-bot-service';

export const deployBot = async (data: DeployBotFormValues, userId: string): Promise<Bot> => {
  const newBotId = uuidv4();

  // Ensure exchanges are of type ExchangePlatform[]
  const exchanges: ExchangePlatform[] = data.exchanges.map(exchange => exchange as ExchangePlatform);

  const newBot = {
    id: newBotId,
    name: data.name,
    description: data.description,
    exchange: exchanges,
    status: 'active' as const,
    type: 'user_bot' as BotType,
    created_date: new Date().toISOString(),
    last_updated: new Date().toISOString(),
    owner_id: userId,
    is_featured: false,
    is_new: true,
    is_best_seller: false,
    signal_token: uuidv4(),
    reverse_signal_token: uuidv4(),
    webhook_url: 'https://api.tradebot365.com/api/webhook/order',
    bot_id: uuidv4(),
    signal_from: 'TradingView' as SignalSource,
    color_scheme: data.colorScheme as ColorScheme,
  };

  console.log('Creating bot with tokens - signal:', newBot.signal_token, 'reverse:', newBot.reverse_signal_token);

  const { error } = await supabase.from('bots').insert([newBot]);
  if (error) throw error;

  // Create shadow bot after successful creation - this will fetch the latest bot data from DB
  try {
    await createShadowBot(newBot);
  } catch (shadowError) {
    console.error('Error creating shadow bot for user bot:', shadowError);
    // Don't fail the main bot creation if shadow bot creation fails
  }

  return newBot;
};
